import React, { Component } from "react";
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
//====== IMPORT CSS LIB =========
import "antd/dist/antd.css";
// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.light.css';

//Navigate
import Login from './Login';
import View from './Index';

class Navigation extends Component {
  render() {
    return (
      <div id="section_bo" className="section_bo">
        {(() => {
          if (this.props.signIn == true) {
            return (
              <>
                <View key="MainViews" />
              </>
            )
          }
          else {
            return (
              <>
                <Route sensitive path="/">

                  <Login key="Login" />
                </Route>
              </>
            )
          }
        })()}
      </div>
    )
  }
}

const mapStateToProps = ({ login }) => ({
  signIn: login.signIn
});

const mapDispatchToProps = (dispatch) => {
  return { signOut: () => dispatch({ type: "sign_out" }) };
};
//functional component, class component
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
